import { z } from 'zod/v3';

import { SortingDirection } from 'common/api-types/common';

export const sortingDirectionSchema = z.custom<SortingDirection>(
  (value): value is SortingDirection => value === 'ASC' || value === 'DESC',
);
